import { PayoutStatus } from '@nemuru-eng/js-api-client';
import { generatePath, useNavigate } from 'react-router-dom';

import { PayoutStatusLabel } from '@/components/modules/Payouts/PayoutsList/components/PayoutStatusLabel';
import { ALLOWED_PAYOUT_STATUSES_FOR_MULTI_SELECT_FILTER } from '@/components/modules/Payouts/PayoutsList/constants/constants';
import { usePayoutsList } from '@/components/modules/Payouts/PayoutsList/hooks/usePayoutList';
import { PayoutsListRowProps } from '@/components/modules/Payouts/PayoutsList/types/PayoutsListRowProps';
import { PayoutsDataGridFields } from '@/components/modules/Payouts/PayoutsList/utils/PayoutsDataGridFields/PayoutsDataGridFields';
import { MultiFilteredList } from '@/components/shared/components/MultiFilteredList';
import { Text } from '@/components/shared/components/Text';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { useOperationsContext } from '@/contexts/OperationsContext/OperationsContext';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const PAYOUT_STATUSES_ITEMS = ALLOWED_PAYOUT_STATUSES_FOR_MULTI_SELECT_FILTER;

const PayoutsList = () => {
  const { fetchPayoutsList } = usePayoutsList();
  const navigate = useNavigate();
  const {
    state: { lastViewedPayoutId },
    actions: { updateOperationsContext },
  } = useOperationsContext();

  const tableColumns = PayoutsDataGridFields();

  return (
    <>
      <MultiFilteredList
        fetchList={fetchPayoutsList}
        dataGridFields={tableColumns}
        onRowClick={(selectedRow: PayoutsListRowProps) => {
          updateOperationsContext({ lastViewedPayoutId: selectedRow.row.id });
          navigate(
            generatePath(DYNAMIC_PAGE_PATHS.PAYOUT, {
              payoutId: selectedRow.row.id,
            }),
          );
        }}
        getRowClassName={(params) => {
          if (params.row.id === lastViewedPayoutId) return 'last-viewed-application';
          else return '';
        }}
        multiselectProps={{
          field: 'payout_status',
          label: <Text tId={'PAYOUT_STATUS'} />,
          defaultLabel: <Text tId={'DEFAULT_STATUSES'} />,
          items: PAYOUT_STATUSES_ITEMS,
          checkBoxRender: (value: PayoutStatus) => <PayoutStatusLabel payoutStatus={value} />,
          filtersValueHandler: undefined,
          defaultItems: ALLOWED_PAYOUT_STATUSES_FOR_MULTI_SELECT_FILTER,
        }}
        dateFilterProps={{
          dateField: 'issue_date',
        }}
        defaultOrderBy={'issue_date'}
        disableSelectionOnClick
      />
    </>
  );
};

export const PayoutsListModule = withPermissionsModule(PayoutsList);
